<template>
  <div>
    <el-input placeholder="" readonly :value="displayValue" :clearable="true" @change="handleChange">
      <template slot="append"><el-button type="primary" @click="open">选择</el-button></template>
    </el-input>

      <mw-dialog title="选择人员" size="small_large" :footerButton="btns" ref="zgDeptDialog" :close-on-click-modal="false">
        <div ref="jstreeMountPoint" style="padding:10px"></div>
      </mw-dialog>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    url: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      btns: [
        {
          label: "确定",
          func: this.close
        }
      ]
    };
  },
  computed: {
    displayValue() {
      if (this.value && this.value.length) {
        return this.value.map(x => x.name).join(", ");
      }
      return "";
    }
  },
  methods: {
    close() {
      this.mwRef("zgDeptDialog").hide();
    },

    async open() {
      this.mwRef("zgDeptDialog").show();
      const jstree = await this.getJstreeInst();
      jstree.settings.core.multiple = this.multiple;
      jstree.settings.checkbox.three_state = this.multiple;
      jstree.settings.checkbox.cascade = this.multiple
        ? "up+down+undetermined"
        : "";
      jstree.refresh(true, true);

      if (this.value && this.value.length > 0) {
        for (let {id} of this.value) {
          jstree.select_node('jstree_node' + id);
        }
      }
    },

    getJstreeInst() {
      if (!this.mwRef("jstreeMountPoint")) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            resolve(this.getJstreeInst());
          }, 100);
        });
      }
      let jstree = $(this.mwRef("jstreeMountPoint")).jstree(true);
      if (!jstree) {
        jstree = $(this.mwRef("jstreeMountPoint"))
          .on("changed.jstree", (e, { selected }) => {
            const jstree = $(this.mwRef("jstreeMountPoint")).jstree(true);
            this.$emit("input", selected.map(x => jstree.get_node(x).data).filter(x => x));
          })
          .jstree({
            core: {
              data: async (curNode, callback) => {
                let groupId = "";
                if (curNode.id === "#") {
                  // it's root node
                  groupId = "";
                } else {
                  groupId = curNode.data.id;
                }

                const departments = (
                  (curNode.data && curNode.data.children) ||
                  []
                ).filter(x => x.type !== "U");

                const url = this.url + "/" + groupId + `?_=randhash${Math.random()}`;
                callback(
                  [
                    ...(await this.mwUtil.ajax(url, { id: groupId })),
                    ...departments
                  ].map(this.formatter)
                );
              },
              strings: {
                "Loading ...": "加载中"
              },
              check_callback: true,
              multiple: this.multiple
            },
            plugins: ["wholerow", "checkbox", "changed"]
          })
          .jstree(true);
      }
      return jstree;
    },

    formatter(x, i, a) {
      const selected = this.value.some(y => y.id === x.id);
      return {
        id: 'jstree_node' + x.id,
        data: x,
        text: x.name,
        icon: x.hasChild ? "fa fa-folder" : "fa fa-leaf",
        li_attr: {
          class: "mw-tree",
          style: "padding:0"
        },
        state: {
          opened: i === 0 && x.hasChild,
          checked: selected,
          selected
        },
        children: x.hasChild ? true : false // (x.children || []).map(this.formatter)
      };
    },

    handleChange(val) {
      if (!val) {
        this.$emit("input", []);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/common/manSelect.vue